/**
 * Length rules for meta title/description (TICKET-10023). Kept separate from
 * useSEO.ts so blog pages (which build title/description themselves before
 * calling useHead) can reuse the same tightening logic.
 */

const TITLE_MAX = 60;
const DESCRIPTION_MAX = 155;

function trimAtWordBoundary(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text;
    const truncated = text.slice(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');
    return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated).trimEnd();
}

/**
 * Fits `raw` (already suffixed with e.g. " | Unified.to" if desired) within the
 * SERP-safe title length. The suffix is dropped before the title itself is
 * trimmed, per the "count includes suffix; drop suffix before keyword" rule.
 */
export function tightenSeoTitle(raw: string, suffix = ''): string {
    if (!raw) return raw;
    const withSuffix = suffix && !raw.includes('|') ? `${raw}${suffix}` : raw;
    if (withSuffix.length <= TITLE_MAX) return withSuffix;
    if (raw.length <= TITLE_MAX) return raw;
    return trimAtWordBoundary(raw, TITLE_MAX);
}

/** Caps a meta description at ~155 chars, trimmed at a word boundary. Never stretches a short one. */
export function trimSeoDescription(raw: string): string {
    if (!raw) return raw;
    if (raw.length <= DESCRIPTION_MAX) return raw;
    return trimAtWordBoundary(raw, 150);
}
